module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAABI0lEQVQokZXSsUtbURQH4C+BLm0sLjZzeqcrYq5DQUGoW10c7OLQsZt7F/8MBwdL1yI4S8FCJ7EdBF9BfKI+OlcRQaFO5XVIrC9Bk/aMB757Duf+amVZgiLPxvAKExjFLxzjc4ip0Fe1siwVeTaJt9jFN5xjBAnz2A4xfeqBp4f7TazgfYjpoP/lIs+aeIeNENPebb+OBezchyDE9BMfsVjt1zGOr/ehSn1Ho8izZ1X4BJeDVIjpN67xtAqvMDYIFnn2SOfSfwfUu2u8HLLqNM5CTBdVuIV2kWezD0x7jtfYrPZv/7GFZfzQOdQ5GpjCDEqsVoNQqyTnMebcJecGJ/iCFt5gLcR01AOHVZFnL7p4PcR0+M+wi9s60fzwX7CLJ7D0B9WlZsEGf5rzAAAAAElFTkSuQmCC"


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/magnifying-glass.png
 ** module id = 175
 ** module chunks = 0
 **/